"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className="w-full py-12 px-6 transition-all duration-[150ms] ease-[cubic-bezier(0.4,0,0.2,1)] opacity-100 translate-y-0 !border-[hsl(0,0%,100%)] !border-1 border-solid !text-[hsl(22,78%,26%)] !bg-[hsl(0,0%,98%)]">
      <div className="mx-auto max-w-7xl flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex-1 text-center md:text-left">
          <h2 className="text-2xl font-semibold mb-2 !text-[hsl(22,78%,26%)] md:text-3xl">
            Ready to Ensure Your Financial Compliance?
          </h2>
          <p className="text-base !text-[hsl(0,0%,0%)] md:text-lg">
            Partner with Salem Ballama Auditing for expert audit, tax advisory, and regulatory support across the UAE.
          </p>
        </div>
        <div className="flex-shrink-0">
          <Link to="/BookConsultationPage">
            <Button className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive shadow-xs h-9 has-[>svg]:px-3 text-foreground-primary px-8 py-3 rounded-md font-semibold border-2 border-primary shadow-soft transition-all duration-[80ms] ease-[cubic-bezier(0.34,1.56,0.64,1)] !border-[hsl(0,0%,98%)] border-solid !bg-[hsl(22,78%,26%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-primary-hover hover:border-primary-hover hover:shadow-medium hover:-translate-y-0.5">
              Book a Consultation
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}